export const FILTER_BAR_HEIGHT = '32px';
export const FILTER_BAR_SECTION_RIGHT_MARGIN_TRELLIS = '200';

// This token should match the token used in QuickFilterSelectBase
// https://git.hubteam.com/HubSpot/customer-data-filters/blob/master/customer-data-filters-ui/static-1.33478/js/components/quickFilters/quickFiltersBar/QuickFilterSelectBase.tsx#L30
export const FILTER_BAR_BUTTON_ACTIVE_BACKGROUND_COLOR_TRELLIS = 'fill-field-hover';